import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Info, ExclamationCircle, Ban, CheckmarkCircle, Question } from '@resultadosdigitais/tangram-react-icons';
import { KINDS } from '../helper';
export const kindMap = new Map([[KINDS.DEFAULT, {
  Icon: null,
  color: '--primary-surface-high-emphasis'
}], [KINDS.PRIMARY, {
  Icon: props => /*#__PURE__*/React.createElement(Info, _extends({
    title: "Information icon",
    titleId: "infoIcon"
  }, props)),
  color: '--primary-surface-high-emphasis'
}], [KINDS.WARNING, {
  Icon: props => /*#__PURE__*/React.createElement(ExclamationCircle, _extends({
    title: "Warning icon",
    titleId: "exclamationIcon"
  }, props)),
  color: '--warning-surface-high-emphasis'
}], [KINDS.DANGER, {
  Icon: props => /*#__PURE__*/React.createElement(Ban, _extends({
    title: "Danger icon",
    titleId: "banIcon"
  }, props)),
  color: '--danger-surface-high-emphasis'
}], [KINDS.SUCCESS, {
  Icon: props => /*#__PURE__*/React.createElement(CheckmarkCircle, _extends({
    title: "Success icon",
    titleId: "checkIcon"
  }, props)),
  color: '--success-surface-high-emphasis'
}], [KINDS.HELP, {
  Icon: props => /*#__PURE__*/React.createElement(Question, _extends({
    title: "Help icon",
    titleId: "questionIcon"
  }, props)),
  color: '--highlight-surface-high-emphasis'
}]]);
export const useKind = kind => {
  if (!kindMap.has(kind)) {
    return kindMap.get(KINDS.PRIMARY);
  }

  return kindMap.get(kind);
};